import "./Common_Expert_Login_Details.css";
import React, { useContext, useState } from "react";
import Common_Call_Button from "../common-send-button/common-call-button/Common_Call_Button";
import Subscription_Needed_Lottie_Modal from "../subscription-needed-lottie-modal/Subscription_Needed_Lottie_Modal";
import { Context } from "../../../utils/context";
import { useNavigate } from "react-router-dom";
import {
  Expert_Call,
  getExpertCustomerList,
} from "../../../features/admin/vendor_expert/Slice";
import { useDispatch } from "react-redux";
import { faCopy, faExpand } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Modal } from "react-bootstrap";
import { IDS } from "../../../utils/IDS";

const Common_Login_Expert_Details = ({ data, onCallClick }) => {
  const { signin, userdata } = useContext(Context);
  const dispatch = useDispatch();
  const [showModal2, setShowModal2] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");
  console.log(
    data,
    "datadatadatadatadatadatadatadatadatadatadatadatadatadatadatadata",
  );

  const navigate = useNavigate();

  const [showModal, setShowModal] = useState(false);

  const handleCopy = (value) => {
    if (!value || !hasSubscription) return;

    navigator.clipboard.writeText(value);
    alert("Number copied!");
  };

  const hasSubscription =
    Array.isArray(userdata?.user_subscription) &&
    userdata.user_subscription.length > 0;

  if (!data) return null;
  // const handleCallClick = (e) => {
  //   setShowModal(true);

  //   if (onCallClick) {
  //     onCallClick(e);
  //   }
  // };

  // const handleCallClick = () => {
  //   if (!hasSubscription) {
  //     setShowModal(true);
  //     return;
  //   }

  //   if (onCallClick) {
  //     onCallClick(data);
  //   }
  // };

  const handleCallClick = async () => {
    if (!hasSubscription) {
      setShowModal(true);
      return;
    }

    try {
      const response = await dispatch(
        Expert_Call({
          inquiry_id: data?.id,
        }),
      ).unwrap();

      console.log("Call API Success:", response);

      await dispatch(getExpertCustomerList());

      // After successful API call
      if (onCallClick) {
        onCallClick(data);
      }
    } catch (error) {
      console.error("Call API Failed:", error);
    }
  };

  const maskedValue = "*****";
  const showValue = (realValue) =>
    hasSubscription ? realValue || "N/A" : maskedValue;

  const handleExpandClick = () => {
    const img = data?.product_image
      ? `${IDS.IMG_URL}${data.product_image}`
      : "/assets/images/expert1.png";

    setSelectedImage(img);
    setShowModal2(true);
  };

  return (
    <div className="expert-login-card">
      <div className="expert-login-card__container">
        <div className="expert-login-card__body">
          <div className="wallet-container">
            <i className="fa-solid fa-wallet"></i>
          </div>

          <div className="expert_top_div">
            {/* <img
                      src={`${IDS.IMG_URL}${data?.construction_image}`}
                      alt={data.name}
                    /> */}
            <img
              className={`${hasSubscription ? "" : "blur"} inner_img`}
              src={
                data?.product_image
                  ? `${IDS.IMG_URL}${data.product_image}`
                  : "/assets/images/expert1.png"
              }
              alt={data?.name || "Vendor"}
            />

            {!hasSubscription && (
              <p className="alert_text">Subscription Needed!</p>
            )}

            {hasSubscription && (
              <div className="expant_div" onClick={handleExpandClick}>
                <FontAwesomeIcon icon={faExpand} className="exopand_text" />
              </div>
            )}
          </div>

          <div className="expert-login-card__info-grid">
            <div className="expert-login-card__detail-row">
              <span className="expert-login-card__label">Name :-</span>
              <span className="expert-login-card__value">{data?.name}</span>
            </div>
            <div className="expert-login-card__detail-row">
              <span className="expert-login-card__label ">
                Mobile Number :-
              </span>
              <span className="expert-login-card__value d-flex align-items-center gap-2">
                {showValue(data?.mobile_number)}

                {hasSubscription && data?.mobile_number && (
                  <FontAwesomeIcon
                    icon={faCopy}
                    style={{ cursor: "pointer" }}
                    title="Copy Number"
                    onClick={() => handleCopy(data?.mobile_number)}
                  />
                )}
              </span>
            </div>

            <div className="expert-login-card__detail-row">
              <span className="expert-login-card__label">Profession :-</span>
              <span className="expert-login-card__value">
                {data?.profession?.name}
              </span>
            </div>

            <div className="expert-login-card__detail-row">
              <span className="expert-login-card__label">
                Sub Profession :-
              </span>
              <span className="expert-login-card__value">
                {data?.sub_profession
                  ?.map((item) => item?.sub_profession_inquiry?.name)
                  .join(", ")}
              </span>
            </div>

            <div className="expert-login-card__detail-row">
              <span className="expert-login-card__label">Descritption :-</span>
              <span className="expert-login-card__value">
                {" "}
                {showValue(data?.description || "-")}
              </span>
            </div>
            {/* <div className="expert-login-card__detail-row">
              <span className="expert-login-card__label">Description :-</span>
              <span className="expert-login-card__value">
                {data?.description || "-"}
              </span>
            </div> */}
            <div className="expert-login-card__detail-row">
              <span className="expert-login-card__label">Work Start :-</span>
              <span className="expert-login-card__value">
                {data?.purchase_date?.name}
              </span>
            </div>
            <div className="expert-login-card__detail-row">
              <span className="expert-login-card__label">State :-</span>
              <span className="expert-login-card__value">
                {showValue(data?.state?.name)}
              </span>
            </div>
            <div className="expert-login-card__detail-row">
              <span className="expert-login-card__label">District :-</span>
              <span className="expert-login-card__value">
                {showValue(data?.district?.name)}
              </span>
            </div>
            <div className="expert-login-card__detail-row">
              <span className="expert-login-card__label">Taluka :-</span>
              <span className="expert-login-card__value">
                {" "}
                {showValue(data?.taluqa?.name)}
              </span>
            </div>
            <div className="expert-login-card__detail-row">
              <span className="expert-login-card__label">Area :-</span>
              <span className="expert-login-card__value">
                {" "}
                {showValue(data?.area)}
              </span>
            </div>
          </div>
        </div>

        <div className="expert-login-card__footer">
          <Common_Call_Button onClick2={handleCallClick} />
        </div>
      </div>

      <Subscription_Needed_Lottie_Modal
        showSubscription={showModal}
        handleSubscriptionClose={() => {
          setShowModal(false);
          navigate("/wallet");
        }}
      />

      <Modal
        show={showModal2}
        onHide={() => setShowModal2(false)}
        centered
        size="lg"
      >
        <Modal.Body className="p-0 text-center">
          <div className="main_show_img_modal_div">
            <div className="showImg_modal">
              <img src={selectedImage} alt="Expanded" className="inner_img" />
            </div>

            <div
              className="icon_holder"
              onClick={() => {
                setShowModal2(false);
              }}
            >
              <img
                src={process.env.PUBLIC_URL + "/assets/icon/close.png"}
                className="close_img"
              />
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default Common_Login_Expert_Details;
